import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount } from 'vue';
import { useTheme } from 'vuetify';

// Vuetify

export default /*@__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  setup(__props, { expose: __expose }) {
  __expose();

const theme = useTheme();

// Lifecycle
onBeforeMount(() => {
  theme.change('light');
});

const __returned__ = { theme }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})